import React from 'react';
import './App.css';
import CommentTable from './components/CommentTable';

const App = () => <div className="App">
    <CommentTable></CommentTable>
</div>

export default App;
